import React from "react";
import { Container1, Container2, Container3, Container4, Design1, TextBox, TextBox2, Wrapper } from "./style";
const Com3 = () => {
  return (
    <Wrapper>
      <Container1>
        <img loading="lazy" src="/assets/img/AffilicateCreator_2.png" alt="phoneImg" />
      </Container1>

      <Container3>
        <TextBox>
          <div>Step. 02</div>
          <div>{"S-Store 가입하기"}</div>
          <div>
            <span>{"S-Store에 가입하면 Creator의 프로필, Store명, 수수료, 주소, 전화번호, "}</span>
            <span>{" 웹사이트 등을 등록하고 수익을 받을 지갑을 선택할 수 있습니다."}</span>
          </div>
        </TextBox>
      </Container3>
      <Design1></Design1>
    </Wrapper>
  );
};

export default Com3;
